import PointGroupCatalog from '@/api/PointGroup/PointGroupCatalog'

const actions = {
  // 特定のownerProfileのPointGroupをsetする
  // belongTypeはoemId, advId, ioIdのいずれか
  async SET_POINT_GROUP_LIST(
    { commit, dispatch },
    { ownerProfileId, belongType, belongId },
  ) {
    const rawPointGroupList = await dispatch('fetchPointGroup', {
      ownerProfileId,
    })
    const pointGroupList = rawPointGroupList.map(pointGroup => {
      pointGroup.selected = false
      return pointGroup
    })
    commit('SET_POINT_GROUP_LIST', { pointGroupList, belongType, belongId })
  },
  // 特定のownerProfileのPointGroupをremoveする
  REMOVE_POINT_GROUP_LIST({ commit }, { ownerProfileId }) {
    commit('REMOVE_POINT_GROUP_LIST', { ownerProfileId })
  },
  RESET_POINT_GROUP_LIST({ commit }) {
    commit('RESET_POINT_GROUP_LIST')
  },
  SET_SELECTED_POINT_GROUP({ commit }, { pointGroupId, isSelected }) {
    commit('SET_SELECTED_POINT_GROUP', { pointGroupId, isSelected })
  },
  SET_SELECTED_ALL_POINT_GROUP({ commit }, { ownerProfileId, isSelected }) {
    commit('SET_SELECTED_ALL_POINT_GROUP', { ownerProfileId, isSelected })
  },
  async fetchPointGroup({ commit }, { ownerProfileId }) {
    return PointGroupCatalog.getGroupList(ownerProfileId)
  },
  SET_ALERT_MODAL_IS_SHOW({ commit }, { isShow }) {
    commit('SET_ALERT_MODAL_IS_SHOW', { isShow })
  },
}

export default actions
